import { render, staticRenderFns } from "./HostingPartial.vue?vue&type=template&id=131a935d&"
import script from "./HostingPartial.vue?vue&type=script&lang=js&"
export * from "./HostingPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports